import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/sections/HeroSection';
import TrustBar from '../../components/feature/sections/TrustBar';
import ServicesOverview from '../../components/feature/sections/ServicesOverview';
import AIAnswerBlock from '../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../components/feature/sections/ServiceAreas';
import TestimonialsSection from '../../components/feature/sections/TestimonialsSection';
import FAQSection from '../../components/feature/sections/FAQSection';
import FinalCTASection from '../../components/feature/sections/FinalCTASection';

const trustItems = [
  { icon: 'ri-hammer-line', text: 'Licensed Installation Crews', subtext: 'Every project' },
  { icon: 'ri-star-fill', text: '600+ Five-Star Reviews', subtext: 'Google & Yelp' },
  { icon: 'ri-shield-check-line', text: 'Fully Insured', subtext: 'Residential & Commercial' },
  { icon: 'ri-vip-diamond-line', text: 'Premium Brand Materials', subtext: 'Shaw, Mohawk & More' },
  { icon: 'ri-map-pin-line', text: 'All NYC Boroughs', subtext: 'Free In-Home Estimates' },
];

const services = [
  {
    icon: 'ri-layout-grid-line',
    title: 'Carpet Installation',
    description: 'Wall-to-wall plush, berber, and patterned carpet in all fiber types — wool, nylon, polyester — installed perfectly for bedrooms, stairs, offices, and living areas.',
    href: '/services',
    image: 'https://public.readdy.ai/ai/img_res/05408a52e676c65e14ce5c73608b17a3.jpg',
  },
  {
    icon: 'ri-artboard-line',
    title: 'Tile & Stone Flooring',
    description: 'Ceramic, porcelain, marble, travertine, slate, and mosaic — our tile crews deliver flawless results in kitchens, bathrooms, hallways, and living spaces.',
    href: '/services',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Luxury Vinyl Plank (LVP)',
    description: '100% waterproof and highly durable, LVP offers the beauty of hardwood or stone with practical performance for families, pets, and high-traffic areas.',
    href: '/services',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Area Rugs',
    description: 'Handmade, machine-woven, Oriental, Persian, and contemporary area rugs in all sizes — available in our Brooklyn showroom with expert guidance.',
    href: '/services',
  },
  {
    icon: 'ri-store-3-line',
    title: 'Showroom Consultation',
    description: 'Our expert design consultants help you navigate 500+ samples to find the ideal flooring for your space, lifestyle, and budget.',
    href: '/services',
  },
];

const aiColumns = [
  {
    heading: 'Carpet Installation Brooklyn',
    paragraphs: [
      'Our carpet installation service covers the full range of pile styles: cut pile (plush), loop pile (berber), and cut & loop patterns. We install carpet in bedrooms, living rooms, hallways, stairs, and commercial spaces.',
      'Every install begins with proper subfloor preparation and padding selection to maximize comfort, sound dampening, and longevity.',
    ],
    bullets: [
      'Wool, nylon, polyester & triexta fibers',
      'Residential & commercial carpet',
      'Stair and hallway installation',
      'Padding upgrade options available',
    ],
  },
  {
    heading: 'Tile & Stone Flooring NYC',
    paragraphs: [
      'From subway tile in bathrooms to large-format porcelain in open-plan living areas, our tile installation crews work to exacting standards. We also install natural stone: marble, travertine, slate, and limestone.',
    ],
    bullets: [
      'Ceramic & porcelain tile',
      'Marble, travertine & natural stone',
      'Mosaic and decorative accents',
      'Heated floor system compatible',
    ],
  },
  {
    heading: 'Luxury Vinyl Plank (LVP)',
    paragraphs: [
      'LVP has become the top choice for Brooklyn homes thanks to its waterproof core, realistic wood or stone visuals, and ease of maintenance. We carry top LVP brands and install with floating or glue-down methods.',
    ],
    bullets: [
      'Waterproof click-lock & glue-down',
      'Wood and stone visual options',
      'Ideal for pets and families',
      'Compatible with radiant heat',
    ],
  },
  {
    heading: 'Area Rugs & Showroom',
    paragraphs: [
      'Our 5,000 sq ft Brooklyn showroom stocks hundreds of area rugs from handmade wool to modern machine-woven designs. Our consultants help you pair the right rug to your existing floors and décor.',
    ],
  },
];

const aiStats = [
  { value: '5K+', label: 'Flooring projects completed' },
  { value: '500+', label: 'Samples in our showroom' },
  { value: '25+', label: 'Years in Brooklyn' },
  { value: '100%', label: 'Satisfaction guaranteed' },
];

const processSteps = [
  { icon: 'ri-store-3-line', title: 'Visit Showroom', description: 'Explore 500+ samples of carpet, tile, LVP, and area rugs at our Brooklyn showroom with design consultant support.' },
  { icon: 'ri-palette-line', title: 'Product Selection', description: 'Choose your material, color, and style. Take samples home to evaluate in your own lighting before you commit.' },
  { icon: 'ri-ruler-line', title: 'Measurement', description: 'We visit your home for precise measurements and deliver a transparent, itemized quote — no hidden fees.' },
  { icon: 'ri-delete-bin-line', title: 'Old Floor Removal', description: 'Our crew removes and disposes of your existing flooring and preps the subfloor to a smooth, level surface.' },
  { icon: 'ri-hammer-line', title: 'Installation', description: 'Expert installation with clean job-site practices, precision craftsmanship, and material-specific techniques.' },
  { icon: 'ri-checkbox-circle-line', title: 'Final Walkthrough', description: 'We inspect every detail with you and make any adjustments needed before signing off on a completed project.' },
];

const benefits = [
  { icon: 'ri-store-3-line', title: 'See It In Person', description: '500+ samples in our 5,000 sq ft Brooklyn showroom. Touch, compare, and take them home before you decide.' },
  { icon: 'ri-hammer-line', title: 'Skilled Install Crews', description: 'Our own licensed installation teams — not subcontractors — handle every project with care and consistency.' },
  { icon: 'ri-vip-diamond-line', title: 'Top Brands', description: 'We source from Shaw, Mohawk, Armstrong, MSI Stone, and other premium brands you can trust to last.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Transparent Pricing', description: 'No hidden fees or bait-and-switch pricing. Our estimates are detailed, clear, and honored at install time.' },
  { icon: 'ri-time-line', title: 'On-Time Delivery', description: 'We respect your schedule. Projects are completed on-time or we make it right — guaranteed.' },
];

const areas = [
  'Brooklyn', 'Park Slope', 'Flatbush', 'Crown Heights', 'Williamsburg',
  'Bay Ridge', 'Bensonhurst', 'Bushwick', 'Cobble Hill', 'DUMBO',
  'Manhattan', 'Queens', 'Staten Island', 'The Bronx',
];

const testimonials = [
  {
    name: 'Sarah K.',
    location: 'Flatbush, Brooklyn',
    rating: 5,
    text: 'Had carpet installed in all three bedrooms and LVP in the kitchen and living room — all in one week. The crew was incredibly professional and the results are beautiful. My apartment looks brand new. Best flooring company in Brooklyn, no question.',
    service: 'Carpet & LVP Installation',
  },
  {
    name: 'Robert M.',
    location: 'Bay Ridge, Brooklyn',
    rating: 5,
    text: 'I had porcelain tile installed throughout my entire main floor. The crew was precise, tidy, and their grout work is immaculate. They even handled my tricky transition to the existing hardwood with total professionalism.',
    service: 'Tile Installation',
  },
  {
    name: 'Lisa H.',
    location: 'Park Slope, Brooklyn',
    rating: 5,
    text: 'The showroom experience made this so easy. I went in not knowing what I wanted and the consultant walked me through everything. I ended up choosing a beautiful wide-plank LVP that looks amazing in my home.',
    service: 'LVP Installation',
  },
  {
    name: 'Tony B.',
    location: 'Williamsburg, Brooklyn',
    rating: 5,
    text: 'We chose Boro Rug for our restaurant remodel — both the dining area floor in stone tile and the bar area in a dark wood LVP. Their commercial team was outstanding from start to finish. On time, on budget, flawless result.',
    service: 'Commercial Flooring',
  },
];

const faqs = [
  {
    question: 'What types of flooring do you install in Brooklyn?',
    answer: 'We install carpet, ceramic and porcelain tile, natural stone (marble, travertine, slate), luxury vinyl plank (LVP), and we carry a wide selection of area rugs in our Brooklyn showroom. Our crews handle residential and commercial projects throughout Brooklyn and all NYC boroughs.',
  },
  {
    question: 'How much does carpet installation cost in Brooklyn?',
    answer: 'Carpet installation in Brooklyn typically runs $3–$7 per square foot including material, padding, and labor. The final cost depends on the carpet style, fiber type, and room conditions. We provide free in-home estimates with no obligation so you know the exact cost before any work begins.',
  },
  {
    question: 'What is the best waterproof flooring for my Brooklyn home?',
    answer: 'Luxury vinyl plank (LVP) is the most popular waterproof flooring choice for Brooklyn homes. It\'s 100% waterproof, extremely durable, realistic in appearance, and easy to maintain. It\'s ideal for kitchens, bathrooms, and high-traffic areas. Visit our showroom to see the full LVP collection.',
  },
  {
    question: 'Do you handle removal of old flooring?',
    answer: 'Yes, we provide full-service flooring replacement. Our crews remove your existing flooring, dispose of the material responsibly, and prepare the subfloor before installing your new floors. This is all included in our project estimate so there are no surprises.',
  },
  {
    question: 'How do I schedule a flooring estimate in Brooklyn?',
    answer: 'Simply call us at (718) 555-0100 or submit an estimate request through our website. We\'ll schedule a free in-home visit to measure your space and discuss materials. Estimates are detailed, transparent, and provided with no obligation to proceed.',
  },
  {
    question: 'Do you install flooring in commercial properties?',
    answer: 'Absolutely. We provide commercial flooring installation throughout Brooklyn and NYC for offices, restaurants, retail spaces, and multi-unit residential buildings. We offer commercial-grade carpet, LVP, and tile with flexible scheduling including evenings and weekends to minimize business disruption.',
  },
];

export default function ServicesPage() {
  return (
    <div className="bg-ivory">
      <Navbar />

      <HeroSection
        headline="Professional Flooring Installation in Brooklyn, NY"
        subheadline="Carpet, tile, stone, luxury vinyl plank, and area rugs — installed by Brooklyn's most experienced flooring crews."
        primaryCTA={{ label: 'Get Free Estimate', href: '/#quote' }}
        secondaryCTA={{ label: 'Visit Our Showroom', href: '/brooklyn' }}
        trustSignal="Trusted by 600+ Brooklyn homeowners"
        bgImage="https://readdy.ai/api/search-image?query=professional%20flooring%20installation%20crew%20laying%20large%20format%20light%20gray%20porcelain%20tile%20in%20bright%20modern%20luxury%20home%20beautiful%20neutral%20interior%20clean%20bright%20workspace%20premium%20quality%20installation&width=1400&height=900&seq=hero-svc2&orientation=landscape"
        badge="Carpet · Tile · LVP · Area Rugs"
        floatingBadgeTitle="Licensed & Insured"
        floatingBadgeText="Expert installation crews for every flooring type"
      />

      <TrustBar items={trustItems} />

      <ServicesOverview
        title="Our Flooring Services"
        subtitle="Complete flooring solutions from material selection to expert installation — all under one roof."
        services={services}
        ctaLabel="Learn More"
      />

      <AIAnswerBlock
        badge="Flooring Installation Brooklyn NY"
        title="Complete Flooring Solutions for Brooklyn Homes & Businesses"
        headline="From carpet and tile to luxury vinyl plank, Boro Rug & Flooring provides the materials and the skilled installation teams to transform any space."
        columns={aiColumns}
        stats={aiStats}
        sidebarTitle="Our Installation Record"
      />

      <ProcessSection
        title="Our Flooring Installation Process"
        subtitle="A proven, transparent process that takes you from first sample to finished floor — without the stress."
        steps={processSteps}
      />

      <WhyChooseUs
        title="Installation Quality You Can See"
        subtitle="Our installation crews are experienced specialists in every flooring type — delivering results that exceed expectations every time."
        benefits={benefits}
        image="https://readdy.ai/api/search-image?query=skilled%20professional%20tile%20setter%20carefully%20placing%20large%20natural%20marble%20stone%20tile%20in%20upscale%20modern%20bathroom%20interior%20bright%20white%20walls%20premium%20luxury%20residential%20renovation&width=800&height=700&seq=why-svc2&orientation=portrait"
        image2="https://readdy.ai/api/search-image?query=close%20up%20luxury%20vinyl%20plank%20floor%20installation%20waterproof%20click%20lock%20plank%20being%20snapped%20into%20place%20bright%20modern%20room%20beautiful%20wood%20grain%20texture&width=400&height=300&seq=why-svc2b&orientation=landscape"
        ctaLabel="Get Free Estimate"
        badge="Why Choose Us"
        badgeTitle="5,000+ Projects"
        badgeSubtext="Completed in Brooklyn & NYC"
      />

      <ServiceAreas
        title="Flooring Installation Across Brooklyn & NYC"
        subtitle="Free in-home estimates available throughout New York City."
        description="Boro Rug & Flooring installs flooring in homes and businesses throughout Brooklyn — from Park Slope to Bay Ridge, Williamsburg to Flatbush. We also serve Manhattan, Queens, Staten Island, and the Bronx. Call to schedule your free in-home estimate today."
        areas={areas}
      />

      <TestimonialsSection testimonials={testimonials} />

      <FAQSection
        title="Flooring Installation FAQ"
        faqs={faqs}
      />

      <FinalCTASection
        headline="Ready for New Floors?"
        subheadline="Schedule your free in-home estimate or visit our Brooklyn showroom. Our team is ready to help you choose and install the perfect flooring."
        bgImage="https://readdy.ai/api/search-image?query=beautiful%20bright%20modern%20living%20room%20with%20stunning%20new%20luxury%20vinyl%20plank%20wood%20look%20floor%20fresh%20white%20walls%20elegant%20contemporary%20furniture%20warm%20natural%20light%20premium%20home%20renovation%20Brooklyn&width=1600&height=900&seq=cta-svc2&orientation=landscape"
        formAction="https://readdy.ai/api/form/d6umjl5t4s7j0tv5i6b0"
        checkItems={['Free in-home estimates', 'All flooring types', 'Residential & commercial']}
      />

      <Footer />
    </div>
  );
}
